import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../api/client';
import type { BoardV2 } from '../types';

/**
 * DASH-2v v2-a — the native pipeline board.
 *
 * Open to any authenticated user server-side as of 2026-08-10 (`get_current_user` on
 * `/api/crm/board-v2`), matching the `pipeline-v2` tab now being visible to everyone; it was
 * `require_admin` before, which 403'd every non-admin who could already see the tab. Rows are still
 * entitlement-scoped per caller by the governed grid, so two people can legitimately get different
 * boards. The ACTIVITY fields remain admin-only and arrive `null` for everyone else — same shape as the
 * backend read flag being off, and the reason the page's activity controls carry one cause-agnostic
 * explanation (`utils/activityCopy.ts`).
 *
 * Short `staleTime` on purpose: during parallel-run the point is to see the effect of a native edit
 * immediately and compare it against v1, so caching it for half an hour would defeat the comparison
 * this board exists for.
 */
export function useBoardV2(enabled = true) {
  return useQuery<BoardV2>({
    queryKey: ['crm', 'board-v2'],
    queryFn: () => apiFetch<BoardV2>('/api/crm/board-v2'),
    staleTime: 30 * 1000,
    enabled,
  });
}
